import React from 'react';
import './Title.scss';

export const Title = () => (
  <div className="title__container">
    <span className="title__text">
      Stopwatch
    </span>
  </div>
);
